import { usePermanentRealtimeDealers } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient } from "hooks";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";

import type { Car } from "models";

export const useCarDealer = (car?: Car) => {
  const { dealers } = usePermanentRealtimeDealers();

  const dealerId = car ? car.dealer_id : typedQueryClient.getQueryData(CarDetailsQueryKeys.details)?.dealer_id;
  if (!dealerId) return;

  return dealers.find(dealer => dealer.id === dealerId);
};
